import React, { Fragment } from "react";
import { Button } from "../../Button";
import { SearchSize, } from "../../types/ArticleHeader";
import { Row } from "react-bootstrap";
import { ArticleHeaderContext } from "../../hooks/articleHeaderContext";
import { Title } from "../../Title";
import { FormContextProvider } from "../../Form";
import parseChildren from "../../utils/parseChildren";
import { Search } from "../../Search";
import { Tab } from "../../Tab";
export function FutureArticleHeader({ title, children, pageInfo, titleLevel = "h2", extra, create, filters, search, loading, uniqueId = 1, id, tabs, dataId, dataTestId, }) {
    let numberOfFilters = 0;
    const filterChildren = parseChildren(children);
    if (filters) {
        numberOfFilters = filterChildren.length;
    }
    return (React.createElement(ArticleHeaderContext.Provider, { value: {
            loading,
            numberOfFilters,
        } },
        React.createElement("div", { className: "article-header article-header--portal", id: id, "data-testid": dataTestId, "data-id": dataId },
            (title || extra || create) && (React.createElement("div", { className: "article-header--heading" },
                title && (React.createElement(Title, { titleLevel: titleLevel },
                    React.createElement(Fragment, null,
                        title,
                        " ",
                        pageInfo && `(${pageInfo.totalRecords})`))),
                tabs && (React.createElement(Tab.Menu, { items: tabs, type: "bar", dataHook: "article-header--tabs" })),
                extra && (React.createElement("div", { className: "article-header-heading--extra" },
                    extra,
                    create && (React.createElement(Button, { type: "primary", label: create.label, onClick: create.onClick, disabled: create.disabled, id: create.id })))))),
            (search || filters) && (React.createElement(AffectBar, { filters: filters, search: search, uniqueId: id || uniqueId, title: title }, children)))));
}
function AffectBar({ search, uniqueId, children, filters, title, }) {
    return (React.createElement(Row, null,
        React.createElement("div", { className: `affectBar--container affectBar--${!search ? "noSearch" : ""}`, "aria-label": `Search and filtering ${title ? `for ${title}` : ""}` },
            React.createElement("div", { className: "affectBar--row" },
                search && (React.createElement(Search, { initialValue: search.initialValue, label: search.label, onChange: search.onChange, uniqueId: uniqueId, debounceTime: search.debounceTime, iconPosition: "left", componentSize: SearchSize.LG })),
                search && filters && (React.createElement("div", { className: "affectBar--filters-divider" })),
                filters && (React.createElement(Filters, { values: filters.values, onSubmit: filters.onSubmit }, children))))));
}
function Filters({ values, onSubmit, children }) {
    return (React.createElement(FormContextProvider, { values: values, onSubmit: onSubmit }, children));
}
